import SignUp from '../features/sign_up/SignUp';

function PageSignUp(): JSX.Element {
	return <SignUp />;
}
export default PageSignUp;
